import { Spinner } from '../ui/spinner';

export const PageLoader = () => {
  return <Spinner className="fixed top-0 h-dvh w-full" />;
};
